<template>
  <!--
    Inspirer Source: https://icons.getbootstrap.com/icons/square/
    Then edited with: SVG Path Visualizer (https://svg-path-visualizer.netlify.app/)
  -->
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-square" viewBox="0 0 16 16">
    <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z    M13 6.5 a1 1 0 0 1 1 1 v1 a1 1 0 0 1-1 1 H3 a1 1 0 0 1-1-1 v-1 a1 1 0 0 1 1-1z"/>
  </svg>
</template>